/**
 * Custom font from env (VITE_FONT_FAMILY, VITE_FONT_URL).
 * When set, injects @font-face and overrides --font-sans, --font-heading, --font-body.
 * Also removes the Google Fonts link so Open Sans/Titillium don't override.
 * Uses direct import.meta.env.VITE_* so Vite replaces them at build time.
 */

const fontFamily = (import.meta.env.VITE_FONT_FAMILY as string | undefined)?.trim();
const fontUrl = ((import.meta.env.VITE_FONT_URL as string | undefined)?.trim() || (fontFamily ? `/fonts/${fontFamily}-Regular.otf` : null)) as string | null;

export function injectFont(): void {
  if (!fontFamily || !fontUrl) return;

  const family = fontFamily.includes("'") ? fontFamily : `'${fontFamily}'`;
  const css = `
@font-face {
  font-family: ${family};
  src: url(${fontUrl}) format('opentype'), url(${fontUrl}) format('otf');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
:root {
  --font-sans: ${family}, sans-serif !important;
  --font-heading: ${family}, sans-serif !important;
  --font-body: ${family}, sans-serif !important;
}
`;
  const style = document.createElement("style");
  style.id = "custom-font";
  style.textContent = css;
  document.head.insertBefore(style, document.head.firstChild);

  // Stop loading Google Fonts (Open Sans, Titillium) so they don't override
  const googleFontLink = document.querySelector('link[href*="fonts.googleapis.com"][href*="Open+Sans"], link[href*="fonts.googleapis.com"][href*="Titillium"]');
  if (googleFontLink) googleFontLink.remove();
}
